import React, { ReactNode } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useModule } from '../context/ModuleContext';
import AppLogo from '../images/logo.png';
import { ShoppingBag, ClipboardList, LogOut } from 'lucide-react';
import './CashierLayout.css';

interface WaiterLayoutProps {
  children: ReactNode;
}

const WaiterLayout: React.FC<WaiterLayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const { company } = useModule();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/waiter-login');
  };

  return (
    <div className="cashier-shell">
      <header className="cashier-header">
        <div className="cashier-header-left">
          <img src={AppLogo} alt="IMS" className="cashier-logo" />
          {company?.name && <span className="cashier-company">{company.name}</span>}
        </div>

        <nav className="cashier-nav">
          <NavLink
            to="/waiter/new-order"
            className={({ isActive }) => `cashier-nav-link${isActive ? ' cashier-nav-link--active' : ''}`}
          >
            <ShoppingBag size={16} strokeWidth={1.75} />
            New Order
          </NavLink>
          <NavLink
            to="/waiter/my-orders"
            className={({ isActive }) => `cashier-nav-link${isActive ? ' cashier-nav-link--active' : ''}`}
          >
            <ClipboardList size={16} strokeWidth={1.75} />
            My Orders
          </NavLink>
        </nav>

        <div className="cashier-header-right">
          <span className="cashier-user">{user?.firstName} {user?.lastName}</span>
          <button className="cashier-logout-btn" onClick={handleLogout} title="Switch waiter">
            <LogOut size={15} strokeWidth={1.75} />
            Switch Waiter
          </button>
        </div>
      </header>

      <main className="cashier-content">{children}</main>
    </div>
  );
};

export default WaiterLayout;
